import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

export const getCustomDefinitionListApi = ({ offset, limit, isAdminRoleRequired }) => {
  const url = endpoints.admin.customDefinition.definitions;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      offset,
      limit,
      is_admin_role_required: isAdminRoleRequired,
    },
  });
};

export const getCustomDefinitionDetailsApi = ({ id }) => {
  const url = endpoints.admin.customDefinition.definition;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      custom_access_definition_id: id,
    },
  });
};

export const createCustomDefinitionApi = (customDefinitionObj) => {
  const url = endpoints.admin.customDefinition.definition;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: customDefinitionObj,
  });
};

export const updateCustomDefinitionApi = ({ id, customDefinitionObj }) => {
  const url = `${endpoints.admin.customDefinition.definition}/${id}`;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      custom_access_definition_id: id,
    },
    body: customDefinitionObj,
  });
};

export const deleteCustomDefinitionApi = ({ id }) => {
  const url = endpoints.admin.customDefinition.definition;
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
    queryParams: {
      custom_access_definition_id: id,
    },
  });
};

export const addEmployeeToCustomDefinitionApi = ({ customDefinitionId: customAccessDefinitionId, empIds }) => {
  const url = endpoints.admin.customDefinition.employee;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      customAccessDefinitionId,
      empIds,
    },
  });
};

export const deleteEmployeeFromCustomDefinitionApi = ({ customDefinitionId, empId }) => {
  const url = endpoints.admin.customDefinition.employee;
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
    queryParams: {
      custom_access_definition_id: customDefinitionId,
      emp_id: empId,
    },
  });
};
